var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",class:_vm.theme ? 'dark' : ''},[_vm._t("default"),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"popper-class":"last-check","type":"date","placeholder":"选择日期","value-format":"yyyy-MM-dd"},on:{"change":_vm.change},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }